/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** WarehouseReserveStatus */
export enum WarehouseReserveStatus {
  InProgress = "in_progress",
  Reserved = "reserved",
  Failed = "failed",
  Cancelled = "cancelled",
}

/** WarehouseFlowSyncState */
export enum WarehouseFlowSyncState {
  InProgress = "in_progress",
  Synced = "synced",
}

/** WarehouseFlowStatus */
export enum WarehouseFlowStatus {
  Planned = "planned",
  Picking = "picking",
  Assembled = "assembled",
  Shipped = "shipped",
  Cancelled = "cancelled",
}

/** SystemOrderStatus */
export enum SystemOrderStatus {
  NeedsApprove = "needs_approve",
  NeedsWork = "needs_work",
  Approved = "approved",
  WarehouseAccepted = "warehouse_accepted",
  WarehousePicking = "warehouse_picking",
  WarehouseAssembled = "warehouse_assembled",
  WarehouseShipped = "warehouse_shipped",
  Completed = "completed",
  Cancelled = "cancelled",
}

/** OrderImportingStatus */
export enum OrderImportingStatus {
  Queued = "queued",
  InProgress = "in_progress",
  Finished = "finished",
  Failed = "failed",
}

/** Module */
export enum Module {
  Delivery = "delivery",
  Warehouse = "warehouse",
  Supply = "supply",
}

/** LayoutDirection */
export enum LayoutDirection {
  OrdersHorizontal = "orders_horizontal",
  OrdersVertical = "orders_vertical",
}

/** AddressProvider */
export enum AddressProvider {
  Google = "google",
  Mapbox = "mapbox",
  Dadata = "dadata",
}

/** ActionKind */
export enum ActionKind {
  ApproveOrder = "approve-order",
  MarkAsNeedsWork = "mark-as-needs-work",
  ApprovalCancelOrder = "approval-cancel-order",
}

/** AccessSettingsArtifactSchema */
export interface AccessSettingsArtifactSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: string;
}

/** AccessSettingsFieldGroupSchema */
export interface AccessSettingsFieldGroupSchema {
  /** Uid */
  uid: string;
  /** Alias */
  alias: string | null;
  /** Name */
  name: string;
}

/** AdaptedOrderFieldDTO */
export interface AdaptedOrderFieldDTO {
  /** Field Uid */
  field_uid: string;
  data: ImportedDataDTO;
}

/** AdaptedOrderItemDTO */
export interface AdaptedOrderItemDTO {
  product: ImportedDataDTO;
  quantity: ImportedDataDTO;
}

/** AddModuleSchema */
export interface AddModuleSchema {
  /** Module */
  module:
    | ({
        kind: "approval";
      } & ApprovalModuleInfoInput)
    | ({
        kind: "final_state";
      } & FinalStateModuleInfoInput)
    | ({
        kind: "warehouse";
      } & WarehouseModuleInfoInput);
}

/** Address */
export interface Address {
  /** Uid */
  uid: string;
  /** As String */
  as_string: string;
  provider?: AddressProvider | null;
  /** Provider Address Uid */
  provider_address_uid?: string | null;
  /** Country Name */
  country_name?: string;
  /** Country Iso Code */
  country_iso_code?: string;
  /** Region Name */
  region_name?: string;
  /** City Name */
  city_name?: string;
  /** Postal Code */
  postal_code?: string;
  /** Street Name */
  street_name?: string;
  /** Street Number */
  street_number?: string | null;
  /** Place Name */
  place_name?: string | null;
  /** Lat */
  lat?: number | null;
  /** Lon */
  lon?: number | null;
}

/** AddressForValidation */
export interface AddressForValidation {
  provider: AddressProvider;
  /** Provider Address Uid */
  provider_address_uid: string;
  /** Street Name */
  street_name: string;
  /** Street Number */
  street_number: string | null;
  /**
   * Place Name
   * Идентификатор помещения. Номер квартиры или номер офиса, например.
   */
  place_name: string | null;
}

/** ApplyActionSchema */
export interface ApplyActionSchema {
  /** Payload */
  payload:
    | CancelOrderParamsDTO
    | ApproveOrderParamsDTO
    | MarkOrderAsNeedsWorkParamsDTO;
}

/** ApprovalModuleInfo */
export interface ApprovalModuleInfoInput {
  /** Uid */
  uid?: string;
  /**
   * Kind
   * @default "approval"
   */
  kind?: "approval";
  settings?: ApprovalModuleSettings;
  info?: ApprovalSavedInfo;
}

/** ApprovalModuleInfo */
export interface ApprovalModuleInfoOutput {
  /** Uid */
  uid?: string;
  /**
   * Kind
   * @default "approval"
   */
  kind?: "approval";
  settings?: ApprovalModuleSettings;
  info?: ApprovalSavedInfo;
  /** Is Removable */
  is_removable: boolean;
}

/** ApprovalModuleSettings */
export interface ApprovalModuleSettings {
  /** Hidden Status Uids */
  hidden_status_uids?: string[];
}

/** ApprovalSavedInfo */
export interface ApprovalSavedInfo {
  /** Stage Uid */
  stage_uid?: string | null;
  /** Approval Route Ref Uid */
  approval_route_ref_uid?: string | null;
}

/** ApprovalStepSchema */
export interface ApprovalStepSchema {
  user_group: UserGroupSchema;
  /** Is Passed */
  is_passed: boolean;
  /** Is Current */
  is_current: boolean;
}

/** ApproveOrderParamsDTO */
export interface ApproveOrderParamsDTO {
  /**
   * Version
   * Текущая версия заказа
   */
  version: string;
  /** Comment */
  comment?: string | null;
}

/** ArtifactAccessPolicySchema */
export interface ArtifactAccessPolicySchema {
  /** Type */
  type: "artifact";
  /** Available Levels */
  available_levels: string[];
  /**
   * Access
   * access level map, stage_uid -> access level
   */
  access: Record<string, string>;
  artifact: AccessSettingsArtifactSchema;
}

/** ArtifactItemSchema */
export interface ArtifactItemSchema {
  /** Type */
  type: "artifact";
  data: ArtifactSchema;
}

/** ArtifactSchema */
export interface ArtifactSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "approval_route" | "order_items" | "reserve_state" | "warehouse_flow";
}

/** AttributeMetaSchema */
export interface AttributeMetaSchema {
  /** Attr */
  attr: string;
  /** Name Name */
  name_name: string;
}

/** AvailableStatusSchema */
export interface AvailableStatusSchema {
  /** Uid */
  uid: string;
  /** Alias */
  alias: string;
}

/** Body_uploadOrderFile */
export interface BodyUploadOrderFile {
  /**
   * Media
   * File (PDF, Excel, Word)
   * @format binary
   */
  media: File;
}

/** Body_uploadOrderImage */
export interface BodyUploadOrderImage {
  /**
   * Media
   * Image file
   * @format binary
   */
  media: File;
}

/** Body_uploadOrderImportFile */
export interface BodyUploadOrderImportFile {
  /**
   * File
   * Excel file
   * @format binary
   */
  file: File;
}

/** CancelOrderParamsDTO */
export interface CancelOrderParamsDTO {
  /**
   * Version
   * Текущая версия заказа
   */
  version: string;
  /** Comment */
  comment: string;
}

/** CatalogDTO */
export interface CatalogDTO {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** CatalogSchema */
export interface CatalogSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  cover: Image | null;
}

/** CatalogWithoutProcessError */
export interface CatalogWithoutProcessError {
  /** Error Id */
  error_id: string;
  /** Title */
  title?: string | null;
  /** Detail */
  detail?: string | null;
  /** Code */
  code?: "catalog_without_process_error";
  /** Status Code */
  status_code?: number | null;
  source?: Source | null;
  /** Meta */
  meta?: object | null;
}

/** CellImportSchema */
export interface CellImportSchema {
  /** Cell */
  cell: string;
}

/** Contact */
export interface Contact {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Email */
  email: string | null;
  /** Phone */
  phone: string;
}

/** ContextSchema */
export interface ContextSchema {
  scope: ContextScopeSchema;
}

/** ContextScopeSchema */
export interface ContextScopeSchema {
  /** Counterparty Modules */
  counterparty_modules: Module[];
  /** ScopePermissions */
  $permissions: {
    /** View Orders */
    view_orders?: boolean;
    /** Export Orders */
    export_orders?: boolean;
    /** Import Orders */
    import_orders?: boolean;
    /** View Import Orders */
    view_import_orders?: boolean;
    /** View Processes */
    view_processes?: boolean;
    /** Create Processes */
    create_processes?: boolean;
    /** Create Projects */
    create_projects?: boolean;
    /** View Projects */
    view_projects?: boolean;
    /** View Counterparty Orders */
    view_counterparty_orders?: boolean;
    /** Export Counterparty Orders */
    export_counterparty_orders?: boolean;
    /** View Epd */
    view_epd?: boolean;
    /** Manage Epd */
    manage_epd?: boolean;
  };
}

/** CounterpartyOrderCargoSchema */
export interface CounterpartyOrderCargoSchema {
  /** Weight */
  weight: string | null;
  /** Volume */
  volume: string | null;
  /** Places */
  places: WarehouseDocumentPlace[] | null;
}

/** CounterpartyOrderCustomerSchema */
export interface CounterpartyOrderCustomerSchema {
  /** Id */
  id: number;
  /** Title */
  title: string;
}

/** CounterpartyOrderModuleSchema */
export interface CounterpartyOrderModuleSchema {
  module: Module;
  status: WarehouseFlowStatus | null;
}

/** CounterpartyOrderSchema */
export interface CounterpartyOrderSchema {
  /** Uid */
  uid: string;
  /** Num */
  num: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  customer: CounterpartyOrderCustomerSchema;
  /** Recipient Name */
  recipient_name: string | null;
  /** Delivery City */
  delivery_city: string | null;
  /** Delivery Address */
  delivery_address: string | null;
  /** Contact Name */
  contact_name: string | null;
  /** Contact Phone */
  contact_phone: string | null;
  /** Delivery Date */
  delivery_date: string | null;
  /** Comment */
  comment: string | null;
  cargo: CounterpartyOrderCargoSchema | null;
  /** Cargo Unavailable */
  cargo_unavailable: boolean;
  status: CounterpartyOrderStatusSchema;
  /** Modules */
  modules: CounterpartyOrderModuleSchema[];
}

/** CounterpartyOrderStatusSchema */
export interface CounterpartyOrderStatusSchema {
  /** Alias */
  alias: string;
  /** Name */
  name: string;
}

/** CounterpartyOrdersCountsSchema */
export interface CounterpartyOrdersCountsSchema {
  /** All */
  all: number;
  /** Warehouse */
  warehouse: number;
  /** Delivery */
  delivery: number;
}

/** CounterpartyWarehouseOrderSchema */
export interface CounterpartyWarehouseOrderSchema {
  /** Uid */
  uid: string;
  /** Num */
  num: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  customer: CounterpartyOrderCustomerSchema;
  /** Recipient Name */
  recipient_name: string | null;
  /** Delivery City */
  delivery_city: string | null;
  /** Delivery Address */
  delivery_address: string | null;
  /** Contact Name */
  contact_name: string | null;
  /** Contact Phone */
  contact_phone: string | null;
  /** Delivery Date */
  delivery_date: string | null;
  /** Comment */
  comment: string | null;
  cargo: CounterpartyOrderCargoSchema | null;
  /** Cargo Unavailable */
  cargo_unavailable: boolean;
  status: WarehouseFlowStatus;
}

/** CreateAccessSettingsDTO */
export interface CreateAccessSettingsDTO {
  user_group: ObjectRef;
}

/** CreateAddressFieldSchema */
export interface CreateAddressFieldSchema {
  /** Type */
  type: "address";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateBoolFieldSchema */
export interface CreateBoolFieldSchema {
  /** Type */
  type: "bool";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateCatalogFieldSchema */
export interface CreateCatalogFieldSchema {
  /** Type */
  type: "catalog";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateContactFieldSchema */
export interface CreateContactFieldSchema {
  /** Type */
  type: "contact";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateDateFieldSchema */
export interface CreateDateFieldSchema {
  /** Type */
  type: "date";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateDatetimeFieldSchema */
export interface CreateDatetimeFieldSchema {
  /** Type */
  type: "datetime";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateFieldGroupSchema */
export interface CreateFieldGroupSchema {
  /** Name */
  name: string;
}

/** CreateMulti_fileFieldSchema */
export interface CreateMultiFileFieldSchema {
  /** Type */
  type: "multi_file";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateMulti_imageFieldSchema */
export interface CreateMultiImageFieldSchema {
  /** Type */
  type: "multi_image";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateNumFieldSchema */
export interface CreateNumFieldSchema {
  /** Type */
  type: "num";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateOrderDTO */
export interface CreateOrderDTO {
  /** Field Groups */
  field_groups?: Record<string, object>;
}

/** CreateProcessDTO */
export interface CreateProcessDTO {
  /**
   * Name
   * @minLength 1
   */
  name: string;
}

/** CreateProjectDTO */
export interface CreateProjectDTO {
  /** Title */
  title: string;
  process: ObjectRef;
}

/** CreateRecipientFieldSchema */
export interface CreateRecipientFieldSchema {
  /** Type */
  type: "recipient";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateStageDTO */
export interface CreateStageDTO {
  /** Name */
  name: string;
  /**
   * Position
   * @min 1
   */
  position: number;
}

/** CreateStageStatusDTO */
export interface CreateStageStatusDTO {
  /** Name */
  name: string;
  /**
   * Position
   * @min 1
   */
  position: number;
}

/** CreateStringFieldSchema */
export interface CreateStringFieldSchema {
  /** Type */
  type: "string";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateTextFieldSchema */
export interface CreateTextFieldSchema {
  /** Type */
  type: "text";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** CreateUserFieldSchema */
export interface CreateUserFieldSchema {
  /** Type */
  type: "user";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** DeliveryInfo */
export interface DeliveryInfo {
  /** Получатель с адресом */
  recipient: Recipient;
  /** Контактная информация */
  contact: Contact;
  /**
   * Delivery Date
   * Дата доставки
   * @format date
   */
  delivery_date: string;
  /**
   * Comment
   * Комментарий
   */
  comment?: string | null;
  address: Address;
}

/** FieldGroupAccessPolicySchema */
export interface FieldGroupAccessPolicySchema {
  /** Type */
  type: "field_group";
  /** Available Levels */
  available_levels: string[];
  /**
   * Access
   * access level map, stage_uid -> access level
   */
  access: Record<string, string>;
  field_group: AccessSettingsFieldGroupSchema;
}

/** FieldGroupItemSchema */
export interface FieldGroupItemSchema {
  /** Type */
  type: "field_group";
  data: FieldGroupSchema;
}

/** FieldGroupPermissionSchema */
export interface FieldGroupPermissionSchema {
  /**
   * View
   * @default false
   */
  view?: boolean;
  /**
   * Update
   * @default false
   */
  update?: boolean;
  /** Fields */
  fields?: Record<string, SimplePermissionSchema>;
}

/** FieldGroupSchema */
export interface FieldGroupSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Fields */
  fields: (
    | ({
        type: "address";
      } & RetrieveAddressFieldSchema)
    | ({
        type: "bool";
      } & RetrieveBoolFieldSchema)
    | ({
        type: "catalog";
      } & RetrieveCatalogFieldSchema)
    | ({
        type: "contact";
      } & RetrieveContactFieldSchema)
    | ({
        type: "date";
      } & RetrieveDateFieldSchema)
    | ({
        type: "datetime";
      } & RetrieveDatetimeFieldSchema)
    | ({
        type: "multi_file";
      } & RetrieveMultiFileFieldSchema)
    | ({
        type: "multi_image";
      } & RetrieveMultiImageFieldSchema)
    | ({
        type: "num";
      } & RetrieveNumFieldSchema)
    | ({
        type: "recipient";
      } & RetrieveRecipientFieldSchema)
    | ({
        type: "string";
      } & RetrieveStringFieldSchema)
    | ({
        type: "text";
      } & RetrieveTextFieldSchema)
    | ({
        type: "user";
      } & RetrieveUserFieldSchema)
  )[];
}

/** FinalStateModuleInfo */
export interface FinalStateModuleInfoInput {
  /** Uid */
  uid?: string;
  /**
   * Kind
   * @default "final_state"
   */
  kind?: "final_state";
  settings?: FinalStateModuleSettings;
  info?: FinalStateSavedInfo;
}

/** FinalStateModuleInfo */
export interface FinalStateModuleInfoOutput {
  /** Uid */
  uid?: string;
  /**
   * Kind
   * @default "final_state"
   */
  kind?: "final_state";
  settings?: FinalStateModuleSettings;
  info?: FinalStateSavedInfo;
  /** Is Removable */
  is_removable: boolean;
}

/** FinalStateModuleSettings */
export interface FinalStateModuleSettings {
  /** Hidden Status Uids */
  hidden_status_uids?: string[];
}

/** FinalStateSavedInfo */
export interface FinalStateSavedInfo {
  /** Stage Uid */
  stage_uid?: string | null;
}

/** GetMappingSettingsParamsDTO */
export interface GetMappingSettingsParamsDTO {
  /** Catalog Uid */
  catalog_uid: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** HistoryOrderStateSchema */
export interface HistoryOrderStateSchema {
  delivery_info: DeliveryInfo;
  order_total: OrderTotal;
}

/** Image */
export interface Image {
  /** Uid */
  uid: string;
  /** Variants */
  variants: Record<string, ImageVariant>;
}

/** ImageVariant */
export interface ImageVariant {
  /** Url */
  url: string;
}

/** ImportFieldDTO */
export interface ImportFieldDTO {
  /** Uid */
  uid?: string;
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Field Group Key */
  field_group_key: string;
  /** Field Key */
  field_key: string;
  /** Field Type */
  field_type: string;
}

/** ImportedDataDTO */
export interface ImportedDataDTO {
  /** Result */
  result: any;
  /** Initial */
  initial: any;
  /** Is Success */
  is_success: boolean;
}

/** InvalidOrderStatusError */
export interface InvalidOrderStatusError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "order_invalid_status";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** LayoutDTO */
export interface LayoutDTO {
  direction: LayoutDirection;
  orders_region: RegionDTO;
  items_region: RegionDTO;
}

/** MappingAttrDTO */
export interface MappingAttrDTO {
  /** Alias */
  alias: string | null;
  /** Name */
  name: string;
  /** Attr */
  attr: string;
  /**
   * Is Required
   * @default false
   */
  is_required?: boolean;
  /**
   * Is Unique
   * @default false
   */
  is_unique?: boolean;
}

/** MappingFieldDTO */
export interface MappingFieldDTO {
  /** Alias */
  alias: string | null;
  /** Name */
  name: string;
  /** Field */
  field: string;
  /** Is Required */
  is_required: boolean;
  /** Available Attributes */
  available_attributes: MappingAttrDTO[];
}

/** MappingSettingsDTO */
export interface MappingSettingsDTO {
  /** Order Fields */
  order_fields: MappingFieldDTO[];
  /** Items Fields */
  items_fields: MappingFieldDTO[];
}

/** MarkOrderAsNeedsWorkParamsDTO */
export interface MarkOrderAsNeedsWorkParamsDTO {
  /**
   * Version
   * Текущая версия заказа
   */
  version: string;
  /** Comment */
  comment: string;
}

/** MoveMultipleToProjectDTO */
export interface MoveMultipleToProjectDTO {
  /** Orders */
  orders: ObjectRef[];
  project: ObjectRef | null;
}

/** MoveToProjectDTO */
export interface MoveToProjectDTO {
  project: ObjectRef | null;
}

/** MoveToStatusAccessPolicySchema */
export interface MoveToStatusAccessPolicySchema {
  /** Type */
  type: "move_to_status";
  /** Available Levels */
  available_levels: string[];
  /**
   * Access
   * access level map, stage_uid -> access level
   */
  access: Record<string, string>;
}

/** MoveToStatusSchema */
export interface MoveToStatusSchema {
  /**
   * Version
   * Текущая версия заказа
   */
  version: string;
  /** To Status Uid */
  to_status_uid: string;
}

/** MultipleMoveToStatusSchema */
export interface MultipleMoveToStatusSchema {
  /** To Status Uid */
  to_status_uid: string;
  /** Orders */
  orders: OrderMoveToStatusRef[];
}

/** ObjectRef */
export interface ObjectRef {
  /** Uid */
  uid: string;
}

/** OrderAccessPolicySchema */
export interface OrderAccessPolicySchema {
  /** Type */
  type: "order";
  /** Available Levels */
  available_levels: string[];
  /**
   * Access
   * access level map, stage_uid -> access level
   */
  access: Record<string, string>;
}

/** OrderApprovedHistoryInfoSchema */
export interface OrderApprovedHistoryInfoSchema {
  /**
   * Kind
   * @default "approved"
   */
  kind?: "approved";
  /** Comment */
  comment: string | null;
}

/** OrderCancelledHistoryInfoSchema */
export interface OrderCancelledHistoryInfoSchema {
  /**
   * Kind
   * @default "cancelled"
   */
  kind?: "cancelled";
  /** Comment */
  comment: string | null;
}

/** OrderCreatedHistoryInfoSchema */
export interface OrderCreatedHistoryInfoSchema {
  /**
   * Kind
   * @default "created"
   */
  kind?: "created";
  order: HistoryOrderStateSchema;
}

/** OrderExportResponseSchema */
export interface OrderExportResponseSchema {
  /**
   * Filename
   * Имя файла экспорта отчетов
   */
  filename: string;
}

/** OrderFileDTO */
export interface OrderFileDTO {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Ext */
  ext: string;
  /** Url */
  url: string;
}

/** OrderHistorySchema */
export interface OrderHistorySchema {
  /** Uid */
  uid: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  user: UserSchema | null;
  /**
   * Order Status
   * @deprecated
   */
  order_status: any;
  /** Order Status Uid */
  order_status_uid: string | null;
  /** Info */
  info:
    | ({
        kind: "approved";
      } & OrderApprovedHistoryInfoSchema)
    | ({
        kind: "cancelled";
      } & OrderCancelledHistoryInfoSchema)
    | ({
        kind: "created";
      } & OrderCreatedHistoryInfoSchema)
    | ({
        kind: "marked_as_needs_work";
      } & OrderMarkedAsNeedsWorkHistoryInfoSchema)
    | ({
        kind: "moved_to_status";
      } & OrderMovedToStatusHistoryInfoSchema)
    | ({
        kind: "system_cancelled";
      } & OrderSystemCancelledHistoryInfoSchema)
    | ({
        kind: "system_moved_to_status";
      } & OrderSystemMovedToStatusHistoryInfoSchema)
    | ({
        kind: "updated";
      } & OrderUpdatedHistoryInfoSchema);
}

/** OrderImageDTO */
export interface OrderImageDTO {
  /** Uid */
  uid: string;
  variants: OrderImageVariants;
}

/** OrderImageVariants */
export interface OrderImageVariants {
  thumbnail: ImageVariant;
  small: ImageVariant;
  medium: ImageVariant;
  big: ImageVariant;
}

/** OrderImportDataSchema */
export interface OrderImportDataSchema {
  /** Uid */
  uid: string;
  /** Order Import Uid */
  order_import_uid: string;
  /** Order Uid */
  order_uid: string | null;
  /** Order Num */
  order_num: number | null;
  /** Is Complete */
  is_complete: boolean;
  /** Fields */
  fields: AdaptedOrderFieldDTO[];
  /** Items */
  items: AdaptedOrderItemDTO[];
  /** OrderImportDataPermissions */
  $permissions: {
    /** Manage */
    manage?: boolean;
  };
}

/** OrderImportSchema */
export interface OrderImportSchema {
  /** Uid */
  uid: string;
  /**
   * Dt Created
   * @format date-time
   */
  dt_created: string;
  /** Orders Total */
  orders_total: number;
  /** Orders Imported */
  orders_imported: number;
  /** Fields */
  fields: ImportFieldDTO[];
  author: UserSchema;
  catalog: CatalogSchema;
  process: SimpleProcessSchema;
  project: SimpleProjectSchema | null;
  uploaded_file: AppDomainsOrderImportSchemasUploadedFileSchema;
  /** OrderImportPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** View Order Import Data */
    view_order_import_data?: boolean;
    /** Create Orders */
    create_orders?: boolean;
    /** Download File */
    download_file?: boolean;
  };
}

/** OrderImportingStateSchema */
export interface OrderImportingStateSchema {
  /** Uid */
  uid: string;
  /** Order Import Uid */
  order_import_uid: string;
  status: OrderImportingStatus;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Finished At */
  finished_at: string | null;
  /** Orders Total */
  orders_total: number;
  /** Orders Processed */
  orders_processed: number;
}

/** OrderItemSchema */
export interface OrderItemSchema {
  /** Uid */
  uid: string;
  /** Quantity */
  quantity: number;
  product: SimpleProductSchema;
  /** Volume */
  volume: string;
  /** Price */
  price: string;
  /** Weight */
  weight: string;
  /** Is Quantity Multiple */
  is_quantity_multiple: boolean;
  /** Available Stock */
  available_stock: number | null;
}

/** OrderItemsArtifactSchema */
export interface OrderItemsArtifactSchema {
  /** Items */
  items: OrderItemSchema[] | null;
  total: OrderTotal;
  /** Total Items */
  total_items: number;
  /**
   * Show Multiplicity Indicator
   * @default false
   */
  show_multiplicity_indicator?: boolean;
  /**
   * Has Not Multiple Items
   * @default false
   */
  has_not_multiple_items?: boolean;
}

/** OrderMarkedAsNeedsWorkHistoryInfoSchema */
export interface OrderMarkedAsNeedsWorkHistoryInfoSchema {
  /**
   * Kind
   * @default "marked_as_needs_work"
   */
  kind?: "marked_as_needs_work";
  /** Comment */
  comment: string | null;
}

/** OrderMoveToStatusRef */
export interface OrderMoveToStatusRef {
  /** Uid */
  uid: string;
  /** Version */
  version: string;
}

/** OrderMovedToStatusHistoryInfoSchema */
export interface OrderMovedToStatusHistoryInfoSchema {
  /**
   * Kind
   * @default "moved_to_status"
   */
  kind?: "moved_to_status";
}

/** OrderOperations */
export interface OrderOperations {
  /** Update */
  update: boolean;
}

/** OrderProcessSchema */
export interface OrderProcessSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** OrderStageSchema */
export interface OrderStageSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** OrderStatusSchema */
export interface OrderStatusSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Alias */
  alias: string;
  stage: OrderStageSchema;
}

/** OrderStructureSchema */
export interface OrderStructureSchema {
  /** Uid */
  uid: string;
  /** Items */
  items: (ArtifactItemSchema | FieldGroupItemSchema)[];
  /** OrderStructurePermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Manage */
    manage?: boolean;
  };
}

/** OrderSystemCancelledHistoryInfoSchema */
export interface OrderSystemCancelledHistoryInfoSchema {
  /**
   * Kind
   * @default "system_cancelled"
   */
  kind?: "system_cancelled";
  /**
   * Source
   * @default "wms"
   */
  source?: "wms";
  /** Comment */
  comment?: string | null;
}

/** OrderSystemMovedToStatusHistoryInfoSchema */
export interface OrderSystemMovedToStatusHistoryInfoSchema {
  /**
   * Kind
   * @default "system_moved_to_status"
   */
  kind?: "system_moved_to_status";
  /**
   * Source
   * @default "wms"
   */
  source?: "wms";
}

/** OrderTotal */
export interface OrderTotal {
  /**
   * Quantity
   * @default 0
   */
  quantity?: number;
  /**
   * Volume
   * @default "0"
   */
  volume?: string;
  /**
   * Price
   * @default "0"
   */
  price?: string;
  /**
   * Weight
   * @default "0"
   */
  weight?: string;
}

/** OrderUpdatedHistoryInfoSchema */
export interface OrderUpdatedHistoryInfoSchema {
  /**
   * Kind
   * @default "updated"
   */
  kind?: "updated";
  before: HistoryOrderStateSchema;
  after: HistoryOrderStateSchema;
}

/** OrderVersionMismatchError */
export interface OrderVersionMismatchError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "order_version_mismatch";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** PartialUpdateStageSchema */
export interface PartialUpdateStageSchema {
  /** Name */
  name?: string;
  /** Module */
  module?: UpdateModuleSettingsSchema;
}

/** PartialUpdateStageStatusSchema */
export interface PartialUpdateStageStatusSchema {
  /** Name */
  name?: string;
  /**
   * Color
   * @format color
   */
  color?: string;
}

/** PreviewDTO */
export interface PreviewDTO {
  /** Orders */
  orders: object[];
  /** Items */
  items: object[];
}

/** PreviewParamsDTO */
export interface PreviewParamsDTO {
  /** Uploaded File Uid */
  uploaded_file_uid: string;
  layout: LayoutDTO;
}

/** ProcessAccessSettingsSchema */
export interface ProcessAccessSettingsSchema {
  /** Uid */
  uid: string;
  user_group: UserGroupSchema;
  /** Policies */
  policies: (
    | ({
        type: "artifact";
      } & ArtifactAccessPolicySchema)
    | ({
        type: "field_group";
      } & FieldGroupAccessPolicySchema)
    | ({
        type: "move_to_status";
      } & MoveToStatusAccessPolicySchema)
    | ({
        type: "order";
      } & OrderAccessPolicySchema)
  )[];
  /** ProcessAccessSettingsPermissions */
  $permissions: {
    /** Manage */
    manage?: boolean;
  };
}

/** ProcessStageSchema */
export interface ProcessStageSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Position */
  position: number;
  /** Is Editable */
  is_editable: boolean;
  /** Is Removable */
  is_removable: boolean;
  /** Statuses */
  statuses: ProcessStageStatusSchema[];
}

/** ProcessStageStatusSchema */
export interface ProcessStageStatusSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Alias */
  alias: string | null;
  /** Position */
  position: number;
  /** Is Editable */
  is_editable: boolean;
  /** Is Removable */
  is_removable: boolean;
  /**
   * Color
   * @format color
   */
  color: string;
}

/** ProductImportError */
export interface ProductImportError {
  /** Error Id */
  error_id: string;
  /** Title */
  title?: string | null;
  /** Detail */
  detail?: string | null;
  /** Code */
  code?: "product_import_error";
  /** Status Code */
  status_code?: number | null;
  source?: Source | null;
  meta: CellImportSchema;
}

/** ProjectDTO */
export interface ProjectDTO {
  /** Uid */
  uid: string;
  /** Title */
  title: string;
}

/** ProjectMetrics */
export interface ProjectMetrics {
  orders?: ProjectOrdersMetrics;
  items?: ProjectOrderItemsMetrics;
}

/** ProjectOrderItemsMetrics */
export interface ProjectOrderItemsMetrics {
  /**
   * Price  Sum
   * @default "0"
   */
  price__sum?: string;
}

/** ProjectOrdersMetrics */
export interface ProjectOrdersMetrics {
  /**
   * Count
   * @default 0
   */
  count?: number;
  /**
   * Is Completed  Count
   * @default 0
   */
  is_completed__count?: number;
  /**
   * Is Completed  Is Delayed  Count
   * @default 0
   */
  is_completed__is_delayed__count?: number;
  /**
   * Is Cancelled  Count
   * @default 0
   */
  is_cancelled__count?: number;
  /**
   * Is Delayed  Count
   * @default 0
   */
  is_delayed__count?: number;
  /** Percent Complete */
  percent_complete: number;
  /** Percent Service Level */
  percent_service_level: number;
}

/** QuantityImportError */
export interface QuantityImportError {
  /** Error Id */
  error_id: string;
  /** Title */
  title?: string | null;
  /** Detail */
  detail?: string | null;
  /** Code */
  code?: "quantity_import_error";
  /** Status Code */
  status_code?: number | null;
  source?: Source | null;
  meta: CellImportSchema;
}

/** RearrangeFieldDTO */
export interface RearrangeFieldDTO {
  /** Uid */
  uid: string;
  /** Position */
  position: number;
}

/** RearrangeStagesDTO */
export interface RearrangeStagesDTO {
  /** Uid */
  uid: string;
  /**
   * Position
   * @min 1
   */
  position: number;
}

/** RearrangeStatusesDTO */
export interface RearrangeStatusesDTO {
  /** Uid */
  uid: string;
  /**
   * Position
   * @min 1
   */
  position: number;
}

/** Recipient */
export interface Recipient {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Code */
  code: string | null;
  address: Address;
  /** Legal Entity Uid */
  legal_entity_uid?: string | null;
}

/** RecordsListGenericSchema[CounterpartyOrderSchema] */
export interface RecordsListGenericSchemaCounterpartyOrderSchema {
  /** Items */
  items: CounterpartyOrderSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[CounterpartyWarehouseOrderSchema] */
export interface RecordsListGenericSchemaCounterpartyWarehouseOrderSchema {
  /** Items */
  items: CounterpartyWarehouseOrderSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[OrderImportDataSchema] */
export interface RecordsListGenericSchemaOrderImportDataSchema {
  /** Items */
  items: OrderImportDataSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[OrderImportSchema] */
export interface RecordsListGenericSchemaOrderImportSchema {
  /** Items */
  items: OrderImportSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveOrderSchema] */
export interface RecordsListGenericSchemaRetrieveOrderSchema {
  /** Items */
  items: RetrieveOrderSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveProjectSchema] */
export interface RecordsListGenericSchemaRetrieveProjectSchema {
  /** Items */
  items: RetrieveProjectSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[SimpleProcessSchema] */
export interface RecordsListGenericSchemaSimpleProcessSchema {
  /** Items */
  items: SimpleProcessSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RegionDTO */
export interface RegionDTO {
  /**
   * Region Start
   * @pattern ^(([A-Za-z]{1,3})(\d+))?$
   */
  region_start: string;
  /** Region End */
  region_end?: string | null;
  /**
   * Size
   * @default 1
   */
  size?: number;
  /** Mapping */
  mapping?: object;
}

/** RemoveModuleSchema */
export interface RemoveModuleSchema {
  module: ObjectRef;
}

/** RequiredMappingAttributeMissing */
export interface RequiredMappingAttributeMissing {
  /** Error Id */
  error_id: string;
  /** Title */
  title?: string | null;
  /** Detail */
  detail?: string | null;
  /** Code */
  code?: "required_mapping_attribute_missing";
  /** Status Code */
  status_code?: number | null;
  source?: Source | null;
  meta: RequiredMappingAttributeMissingMeta;
}

/** RequiredMappingAttributeMissingMeta */
export interface RequiredMappingAttributeMissingMeta {
  /** Field */
  field: string;
  /** Field Name */
  field_name: string;
  /** Variants */
  variants: AttributeMetaSchema[];
}

/** RequiredMappingFieldMissing */
export interface RequiredMappingFieldMissing {
  /** Error Id */
  error_id: string;
  /** Title */
  title?: string | null;
  /** Detail */
  detail?: string | null;
  /** Code */
  code?: "required_mapping_field_missing";
  /** Status Code */
  status_code?: number | null;
  source?: Source | null;
  meta: RequiredMappingFieldMissingMeta;
}

/** RequiredMappingFieldMissingMeta */
export interface RequiredMappingFieldMissingMeta {
  /** Field */
  field: string;
  /** Field Name */
  field_name: string;
}

/** ReserveStateSchema */
export interface ReserveStateSchema {
  status: WarehouseReserveStatus;
  /** Error */
  error?: string | null;
}

/** RetrieveAddressFieldSchema */
export interface RetrieveAddressFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "address";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveApprovalRouteSchema */
export interface RetrieveApprovalRouteSchema {
  /** Is Finished */
  is_finished: boolean;
  /** Steps */
  steps: ApprovalStepSchema[];
}

/** RetrieveBoolFieldSchema */
export interface RetrieveBoolFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "bool";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveCatalogFieldSchema */
export interface RetrieveCatalogFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "catalog";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveContactFieldSchema */
export interface RetrieveContactFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "contact";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveDateFieldSchema */
export interface RetrieveDateFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "date";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveDatetimeFieldSchema */
export interface RetrieveDatetimeFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "datetime";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveMulti_fileFieldSchema */
export interface RetrieveMultiFileFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "multi_file";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveMulti_imageFieldSchema */
export interface RetrieveMultiImageFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "multi_image";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveNumFieldSchema */
export interface RetrieveNumFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "num";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveOrderSchema */
export interface RetrieveOrderSchema {
  /** Uid */
  uid: string;
  /** Num */
  num: number;
  /** Version */
  version: string;
  process: OrderProcessSchema | null;
  project: ProjectDTO | null;
  current_status: OrderStatusSchema | null;
  /** Current Status Uid */
  current_status_uid: string;
  $operations: OrderOperations;
  /** $Available Statuses */
  $available_statuses: AvailableStatusSchema[];
  /** $Actions */
  $actions: ActionKind[];
  /** $Field Groups */
  $field_groups: Record<string, FieldGroupPermissionSchema> | null;
  /** Field Groups */
  field_groups: Record<string, object | null> | null;
  /** Artifacts */
  artifacts: Record<string, object | null> | null;
  /** $Artifacts */
  $artifacts: Record<string, SimplePermissionSchema> | null;
  /** OrderPermissions */
  $permissions: {
    /** Cancel */
    cancel?: boolean;
    /** View */
    view?: boolean;
    /** Update */
    update?: boolean;
    /** Move To Status */
    move_to_status?: boolean;
    /** Move To Project */
    move_to_project?: boolean;
  };
}

/** RetrieveProcessSchema */
export interface RetrieveProcessSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Stages */
  stages: ProcessStageSchema[];
  /** Modules */
  modules: (
    | ({
        kind: "approval";
      } & ApprovalModuleInfoOutput)
    | ({
        kind: "final_state";
      } & FinalStateModuleInfoOutput)
    | ({
        kind: "warehouse";
      } & WarehouseModuleInfoOutput)
  )[];
  order_structure: OrderStructureSchema;
  /** ProcessPermissions */
  $permissions: {
    /** Create Access Settings */
    create_access_settings?: boolean;
    /** Manage */
    manage?: boolean;
    /** View */
    view?: boolean;
    /** View Access Settings */
    view_access_settings?: boolean;
    /** View Order Structure */
    view_order_structure?: boolean;
  };
}

/** RetrieveProjectSchema */
export interface RetrieveProjectSchema {
  /** Uid */
  uid: string;
  /** Title */
  title: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at: string | null;
  process: SimpleProcessSchema;
  metrics: ProjectMetrics;
  /** Is Archived */
  is_archived: boolean;
  /** ProjectPermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** Manage */
    manage?: boolean;
  };
}

/** RetrieveRecipientFieldSchema */
export interface RetrieveRecipientFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "recipient";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveStringFieldSchema */
export interface RetrieveStringFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "string";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveTextFieldSchema */
export interface RetrieveTextFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "text";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RetrieveUserFieldSchema */
export interface RetrieveUserFieldSchema {
  /** Uid */
  uid: string;
  /** Type */
  type: "user";
  /** Name */
  name: string;
  /** Read Only */
  read_only: boolean;
  /** Is Required */
  is_required: boolean;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
  /** Settings */
  settings?: null;
}

/** RunOrderImportParamsDTO */
export interface RunOrderImportParamsDTO {
  /** Catalog Uid */
  catalog_uid: string;
  /** Project Uid */
  project_uid?: string | null;
  /** Uploaded File Uid */
  uploaded_file_uid: string;
  layout: LayoutDTO;
}

/** SimpleFieldGroupSchema */
export interface SimpleFieldGroupSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Is System */
  is_system: boolean;
  /** Alias */
  alias: string | null;
}

/** SimplePermissionSchema */
export interface SimplePermissionSchema {
  /**
   * View
   * @default false
   */
  view?: boolean;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/** SimpleProcessSchema */
export interface SimpleProcessSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** SimpleProductSchema */
export interface SimpleProductSchema {
  /** Uid */
  uid: string;
  /**
   * Title
   * Название
   */
  title: string;
  /**
   * Code
   * Артикул
   */
  code: string | null;
  /**
   * Price
   * Стоимость
   */
  price: string | null;
  /**
   * Package Amount
   * Кратность упаковки
   */
  package_amount: number | null;
}

/** SimpleProjectSchema */
export interface SimpleProjectSchema {
  /** Uid */
  uid: string;
  /** Title */
  title: string;
}

/** UniqueMappingAttributeMissing */
export interface UniqueMappingAttributeMissing {
  /** Error Id */
  error_id: string;
  /** Title */
  title?: string | null;
  /** Detail */
  detail?: string | null;
  /** Code */
  code?: "unique_mapping_attribute_missing";
  /** Status Code */
  status_code?: number | null;
  source?: Source | null;
  /** Meta */
  meta?: object | null;
}

/** UpdateAddressFieldSchema */
export interface UpdateAddressFieldSchema {
  /** Type */
  type: "address";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateArtifactAccessPolicyDTO */
export interface UpdateArtifactAccessPolicyDTO {
  /** Type */
  type: "artifact";
  /** Access */
  access: Record<string, string>;
  artifact: ObjectRef;
}

/** UpdateBoolFieldSchema */
export interface UpdateBoolFieldSchema {
  /** Type */
  type: "bool";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateCatalogFieldSchema */
export interface UpdateCatalogFieldSchema {
  /** Type */
  type: "catalog";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateContactFieldSchema */
export interface UpdateContactFieldSchema {
  /** Type */
  type: "contact";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateDateFieldSchema */
export interface UpdateDateFieldSchema {
  /** Type */
  type: "date";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateDatetimeFieldSchema */
export interface UpdateDatetimeFieldSchema {
  /** Type */
  type: "datetime";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateFieldGroupAccessPolicyDTO */
export interface UpdateFieldGroupAccessPolicyDTO {
  /** Type */
  type: "field_group";
  /** Access */
  access: Record<string, string>;
  field_group: ObjectRef;
}

/** UpdateFieldGroupSchema */
export interface UpdateFieldGroupSchema {
  /** Name */
  name: string;
}

/**
 * UpdateModuleSettingsSchema
 * Can't change module kind of stage.
 */
export interface UpdateModuleSettingsSchema {
  /** Settings */
  settings:
    | ApprovalModuleSettings
    | FinalStateModuleSettings
    | WarehouseModuleSettings;
}

/** UpdateMoveToStatusAccessPolicyDTO */
export interface UpdateMoveToStatusAccessPolicyDTO {
  /** Type */
  type: "move_to_status";
  /** Access */
  access: Record<string, string>;
}

/** UpdateMulti_fileFieldSchema */
export interface UpdateMultiFileFieldSchema {
  /** Type */
  type: "multi_file";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateMulti_imageFieldSchema */
export interface UpdateMultiImageFieldSchema {
  /** Type */
  type: "multi_image";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateNumFieldSchema */
export interface UpdateNumFieldSchema {
  /** Type */
  type: "num";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateOrderAccessPolicyDTO */
export interface UpdateOrderAccessPolicyDTO {
  /** Type */
  type: "order";
  /** Access */
  access: Record<string, string>;
}

/** UpdateOrderItemDTO */
export interface UpdateOrderItemDTO {
  /** Product Uid */
  product_uid: string;
  /**
   * Quantity
   * @min 1
   */
  quantity: number;
}

/** UpdateOrderItemsArtifactDTO */
export interface UpdateOrderItemsArtifactDTO {
  /** Items */
  items: UpdateOrderItemDTO[];
}

/** UpdateOrderParamsDTO */
export interface UpdateOrderParamsDTO {
  /**
   * Version
   * Текущая версия заказа
   */
  version: string;
  /** Field Groups */
  field_groups?: Record<string, object>;
  /** Artifacts */
  artifacts?: Record<string, object>;
}

/** UpdateProcessAccessSettingsDTO */
export interface UpdateProcessAccessSettingsDTO {
  /** Policies */
  policies: (
    | ({
        type: "artifact";
      } & UpdateArtifactAccessPolicyDTO)
    | ({
        type: "field_group";
      } & UpdateFieldGroupAccessPolicyDTO)
    | ({
        type: "move_to_status";
      } & UpdateMoveToStatusAccessPolicyDTO)
    | ({
        type: "order";
      } & UpdateOrderAccessPolicyDTO)
  )[];
}

/** UpdateProjectDTO */
export interface UpdateProjectDTO {
  /** Title */
  title: string;
}

/** UpdateRecipientFieldSchema */
export interface UpdateRecipientFieldSchema {
  /** Type */
  type: "recipient";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateStringFieldSchema */
export interface UpdateStringFieldSchema {
  /** Type */
  type: "string";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateTextFieldSchema */
export interface UpdateTextFieldSchema {
  /** Type */
  type: "text";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UpdateUserFieldSchema */
export interface UpdateUserFieldSchema {
  /** Type */
  type: "user";
  /** Name */
  name: string;
  /** Is Required */
  is_required: boolean;
  /** Settings */
  settings?: null;
}

/** UploadedImageSchema */
export interface UploadedImageSchema {
  /** Uid */
  uid: string;
  variants: UploadedImageVariantsSchema;
}

/** UploadedImageVariantsSchema */
export interface UploadedImageVariantsSchema {
  thumbnail: ImageVariant;
}

/** UserDTO */
export interface UserDTO {
  /** Id */
  id: number;
  /** Username */
  username: string;
  /** Name */
  name: string;
}

/** UserGroupSchema */
export interface UserGroupSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
}

/** UserRef */
export interface UserRef {
  /** Id */
  id: number;
}

/** UserSchema */
export interface UserSchema {
  /** Id */
  id: number;
  /** Username */
  username: string;
  /** Name */
  name: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** WarehouseDocumentPlace */
export interface WarehouseDocumentPlace {
  /** Type */
  type: string;
  /** Amount */
  amount: number;
}

/** WarehouseFlowSchema */
export interface WarehouseFlowSchema {
  status: WarehouseFlowStatus | null;
  sync_state: WarehouseFlowSyncState;
  /** Warehouse Uid */
  warehouse_uid: string | null;
  /** External Document Uid */
  external_document_uid: string | null;
  /** External Document Number */
  external_document_number: string | null;
  /** Picking At */
  picking_at: string | null;
  /** Assembled At */
  assembled_at: string | null;
  /** Shipped At */
  shipped_at: string | null;
  /** Last Error Message */
  last_error_message: string | null;
}

/** WarehouseModuleInfo */
export interface WarehouseModuleInfoInput {
  /** Uid */
  uid?: string;
  /**
   * Kind
   * @default "warehouse"
   */
  kind?: "warehouse";
  settings?: WarehouseModuleSettings;
  info?: WarehouseSavedInfo;
}

/** WarehouseModuleInfo */
export interface WarehouseModuleInfoOutput {
  /** Uid */
  uid?: string;
  /**
   * Kind
   * @default "warehouse"
   */
  kind?: "warehouse";
  settings?: WarehouseModuleSettings;
  info?: WarehouseSavedInfo;
  /** Is Removable */
  is_removable: boolean;
}

/** WarehouseModuleSettings */
export interface WarehouseModuleSettings {
  /** Hidden Status Uids */
  hidden_status_uids?: string[];
}

/** WarehouseSavedInfo */
export interface WarehouseSavedInfo {
  /** Stage Uid */
  stage_uid?: string | null;
  /** Reserve State Ref Uid */
  reserve_state_ref_uid?: string | null;
  /** Warehouse Flow Ref Uid */
  warehouse_flow_ref_uid?: string | null;
}

/** WarehouseSwitchedOffError */
export interface WarehouseSwitchedOffError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_switched_off";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WmsServiceUnavailableError */
export interface WmsServiceUnavailableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "wms_service_unavailable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** _Source */
export interface Source {
  /** Pointer */
  pointer?: string | null;
  /** Header */
  header?: string | null;
  /** Parameter */
  parameter?: string | null;
}

/** UploadedFileSchema */
export interface AppDomainsOrderImportSchemasUploadedFileSchema {
  /** Uid */
  uid: string;
  /** Filename */
  filename: string;
  /**
   * Dt Uploaded
   * @format date-time
   */
  dt_uploaded: string;
}

/** UploadedFileSchema */
export interface AppDomainsOrderStructureOrderFileDtoUploadedFileSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  /** Ext */
  ext: string;
  /** Url */
  url: string;
}

/** ApprovalCancelledStatusNotConfiguredError */
export interface ApprovalCancelledStatusNotConfiguredError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "approval_cancelled_status_not_configured";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ApprovalForwardMoveForbiddenError */
export interface ApprovalForwardMoveForbiddenError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "approval_forward_move_forbidden";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** ApprovalStatusChangeRequiresApprovedError */
export interface ApprovalStatusChangeRequiresApprovedError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "approval_status_change_requires_approved";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** OrderFinalStateMoveForbiddenError */
export interface OrderFinalStateMoveForbiddenError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "order_final_state_move_forbidden";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** InvalidOrderApprovalStepError */
export interface InvalidOrderApprovalStepError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "order_invalid_approval_step";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** OrderProductLimitExceededError */
export interface OrderProductLimitExceededError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "order_product_limit_exceeded";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UserServiceUnavailableError */
export interface UserServiceUnavailableError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "user_service_unavailable";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** UpdateNotPermittedError */
export interface UpdateNotPermittedError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_update_restricted_field";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseCancelForbiddenEnteredError */
export interface WarehouseCancelForbiddenEnteredError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_cancel_forbidden_entered";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseCancelForbiddenReserveInProgressError */
export interface WarehouseCancelForbiddenReserveInProgressError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_cancel_forbidden_reserve_in_progress";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseCompleteBeforeStageError */
export interface WarehouseCompleteBeforeStageError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_complete_before_stage";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseFlowCancelledError */
export interface WarehouseFlowCancelledError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_flow_cancelled";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseManualMoveForbiddenError */
export interface WarehouseManualMoveForbiddenError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_manual_move_forbidden";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseMoveForwardOnlyError */
export interface WarehouseMoveForwardOnlyError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_move_forward_only";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseOrderLockedError */
export interface WarehouseOrderLockedError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_order_locked";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseReentryForbiddenError */
export interface WarehouseReentryForbiddenError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_reentry_forbidden";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** WarehouseReserveNotConfirmedError */
export interface WarehouseReserveNotConfirmedError {
  /** Error Id */
  error_id: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Detail
   * @default null
   */
  detail?: string | null;
  /** Code */
  code?: "warehouse_reserve_not_confirmed";
  /**
   * Status Code
   * @default null
   */
  status_code?: number | null;
  /** @default null */
  source?: null;
  /**
   * Meta
   * @default null
   */
  meta?: object | null;
}

/** EpdState */
export enum EpdState {
  Error = "error",
  NeedsData = "needs_data",
  AwaitingWarehouse = "awaiting_warehouse",
  RevokeNeedsSigner = "revoke_needs_signer",
  AwaitingClient = "awaiting_client",
  AwaitingForwarder = "awaiting_forwarder",
  AwaitingOperator = "awaiting_operator",
  AwaitingShipment = "awaiting_shipment",
  Completed = "completed",
  Revoked = "revoked",
  Cancelled = "cancelled",
}

/** EpdDocumentKind */
export enum EpdDocumentKind {
  ForwardingOrder = "forwarding_order",
  ForwardingReceipt = "forwarding_receipt",
}

/** EpdTitleCode */
export enum EpdTitleCode {
  T1 = "t1",
  T2 = "t2",
  T3 = "t3",
  Receipt = "receipt",
}

/** EpdTitleStatus */
export enum EpdTitleStatus {
  NoDraft = "no_draft",
  DraftCreating = "draft_creating",
  AwaitingSignature = "awaiting_signature",
  DraftRecycling = "draft_recycling",
  Prepared = "prepared",
  Sending = "sending",
  Sent = "sent",
}

/** EpdSigningRequestStatus */
export enum EpdSigningRequestStatus {
  Waiting = "waiting",
  Blocked = "blocked",
  Ready = "ready",
  Completed = "completed",
  Cancelled = "cancelled",
}

/** EpdParty */
export enum EpdParty {
  Client = "client",
  Forwarder = "forwarder",
}

/** EpdPrecheckCode */
export enum EpdPrecheckCode {
  LegalEntityMissing = "legal_entity_missing",
  FullNameMissing = "full_name_missing",
  ClientIsEntrepreneur = "client_is_entrepreneur",
  ForwarderUndefined = "forwarder_undefined",
  ForwarderRegistryMissing = "forwarder_registry_missing",
  ContractMissing = "contract_missing",
  EdoBoxMissing = "edo_box_missing",
  WarehouseProviderMissing = "warehouse_provider_missing",
  WarehouseAddressMissing = "warehouse_address_missing",
  RecipientMissing = "recipient_missing",
  RegionUnknown = "region_unknown",
  WarehouseMeasurementsMissing = "warehouse_measurements_missing",
  WarehouseUnitsUnsupported = "warehouse_units_unsupported",
  FormatViolation = "format_violation",
}

/** EpdPrecheckIssue */
export interface EpdPrecheckIssue {
  code: EpdPrecheckCode;
  text: string;
  field: string;
  fixed_by: "client" | "orbis" | "support";
}

/** EpdWorkflowSchema */
export interface EpdWorkflowSchema {
  uid: string;
  scenario: "forwarding";
  status: "active" | "completed" | "cancelled";
  epd_state: EpdState;
  closed_at: string | null;
}

/** EpdDocumentPartySchema */
export interface EpdDocumentPartySchema {
  role: EpdParty;
  le_uid: string;
  name: string | null;
}

/** EpdTitleSchema */
export interface EpdTitleSchema {
  uid: string;
  title: EpdTitleCode;
  party: EpdParty;
  party_le_uid: string;
  status: EpdTitleStatus;
  status_changed_at: string;
  file_name: string | null;
  has_file: boolean;
  has_signature: boolean;
  signer: Record<string, unknown> | null;
  sent_at: string | null;
}

/** EpdSigningRequestSchema */
export interface EpdSigningRequestSchema {
  uid: string;
  title: EpdTitleCode;
  party: EpdParty;
  party_le_uid: string | null;
  status: EpdSigningRequestStatus;
  blocked_reason: "data" | "manual" | null;
  issues: EpdPrecheckIssue[];
  failures: number;
  next_attempt_at: string | null;
  last_error: string | null;
  completed_at: string | null;
  completed_by: string | null;
  can_sign: boolean;
  can_reset: boolean;
}

/** EpdContentChangeSchema */
export interface EpdContentChangeSchema {
  field: string;
  before: unknown;
  after: unknown;
}

/** EpdDiscrepancySchema */
export interface EpdDiscrepancySchema {
  at: string;
  comparable: boolean;
  fields: EpdContentChangeSchema[];
  issues: EpdPrecheckIssue[];
}

/** EpdPoaVerdict */
export interface EpdPoaVerdict {
  severity?: string | null;
  status?: string | null;
  text?: string | null;
  error_code?: string | null;
}

/** EpdOperatorState */
export interface EpdOperatorState {
  status?: { text: string | null; severity: string | null };
  poa?: EpdPoaVerdict | null;
  titles?: Partial<Record<EpdTitleCode, {
    signed: boolean;
    signature_valid: boolean | null;
    delivered: boolean;
    poa: EpdPoaVerdict | null;
  }>>;
  outer_statuses?: {
    docflow: string | null;
    named_id: string;
    text: string;
    type: string;
    details: Record<string, unknown>[];
  }[];
  outer_docflows?: unknown[];
}

/** EpdDocumentSchema */
export interface EpdDocumentSchema {
  uid: string;
  kind: EpdDocumentKind;
  number: string;
  doc_date: string;
  state: EpdState;
  parent_document_uid: string | null;
  gis_uid: string | null;
  discrepancy: EpdDiscrepancySchema | null;
  operator_state: EpdOperatorState | null;
  errors: Record<string, unknown>[];
  parties: EpdDocumentPartySchema[];
  titles: EpdTitleSchema[];
  requests: EpdSigningRequestSchema[];
}

/** EpdOrderTabSchema */
export interface EpdOrderTabSchema {
  workflow: EpdWorkflowSchema | null;
  documents: EpdDocumentSchema[];
  feed_stalled: boolean;
}

/** EpdCertificateSchema */
export interface EpdCertificateSchema {
  thumbprint: string;
  snils?: string | null;
  inn?: string | null;
  organization_inn?: string | null;
  last_name?: string | null;
  given_names?: string | null;
}

/** EpdSigningContextRequestSchema */
export interface EpdSigningContextRequestSchema {
  certificates: EpdCertificateSchema[];
}

/** EpdSigningGroundSchema */
export interface EpdSigningGroundSchema {
  poa_uid: string;
  is_head: boolean;
  number: string | null;
  last_name: string | null;
  first_name: string | null;
  middle_name: string | null;
  position: string | null;
  valid_until: string | null;
}

/** EpdSigningEntitySchema */
export interface EpdSigningEntitySchema {
  uid: string;
  name: string;
  inn: string;
}

/** EpdSigningContextSchema */
export interface EpdSigningContextSchema {
  legal_entity: EpdSigningEntitySchema;
  certificates: { thumbprint: string; grounds: EpdSigningGroundSchema[] }[];
}

/** EpdPreparedSigningSchema */
export interface EpdPreparedSigningSchema {
  job_uid: string;
  title_uid: string;
  title: EpdTitleCode;
  subscriber: EpdSigningEntitySchema;
}

/** SigningPerson */
export interface SigningPerson {
  last_name: string;
  first_name: string;
  middle_name?: string | null;
  position?: string | null;
  poa_uid?: string | null;
}

/** EpdPrepareSignatureSchema */
export interface EpdPrepareSignatureSchema {
  job_uid: string;
  person: SigningPerson;
}

/** EpdSigningFileSchema */
export interface EpdSigningFileSchema {
  job_uid: string;
  content_base64: string;
}

/** EpdConfirmSignatureSchema */
export interface EpdConfirmSignatureSchema {
  job_uid: string;
  signature: string;
}

/** EpdConfirmedSigningSchema */
export interface EpdConfirmedSigningSchema {
  job_uid: string;
  title_uid: string;
  status: EpdTitleStatus;
}

/** EpdOrderLinkSchema */
export interface EpdOrderLinkSchema {
  uid: string;
  num: number;
  process_uid: string | null;
  project_uid: string | null;
  is_visible: boolean;
}

/** EpdAwaitingRequestSchema */
export interface EpdAwaitingRequestSchema {
  uid: string;
  title: EpdTitleCode;
  can_sign: boolean;
  signer: {
    actor: "user" | "worker";
    user_id: number | null;
    name: string;
  } | null;
}

/** EpdRegistryRowSchema */
export interface EpdRegistryRowSchema {
  uid: string;
  kind: EpdDocumentKind;
  number: string;
  doc_date: string;
  state: EpdState;
  discrepancy_at: string | null;
  parent_document_uid: string | null;
  parent_number: string | null;
  parties: EpdDocumentPartySchema[];
  order: EpdOrderLinkSchema;
  request: EpdAwaitingRequestSchema | null;
}

/** RecordsListGenericSchemaEpdRegistryRowSchema */
export interface RecordsListGenericSchemaEpdRegistryRowSchema {
  items: EpdRegistryRowSchema[];
  total: number;
}

/** EpdSigningCountSchema */
export interface EpdSigningCountSchema {
  count: number;
}

/** EpdRegistryFilters */
export interface EpdRegistryFilters {
  kind?: EpdDocumentKind;
  state?: EpdState[];
  date_from?: string;
  date_to?: string;
  order_num?: number;
  awaiting_me?: boolean;
  discrepancy?: boolean;
  limit?: number;
  offset?: number;
}
